import { render, staticRenderFns } from "./BoxLabel.html?vue&type=template&id=718f49d0&external"
import script from "./BoxLabel.ts?vue&type=script&lang=ts&external"
export * from "./BoxLabel.ts?vue&type=script&lang=ts&external"
import style0 from "./BoxLabel.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports